import React from 'react'
import { blogData } from '../data/blog-data'
import { Link } from 'react-router-dom'

export default function BlogOne() {
  return (
        <div className="row">
            {blogData.slice(0,3).map((item,index)=>{
                return(
                    <div className="col-lg-4 col-md-6 mt-4 pt-2" key={index}>
                        <div className="card blog-post rounded border-0 shadow">
                            <div className="blog-img d-block overflow-hidden position-relative">
                                <img src={item.image} className="img-fluid rounded-top" alt=""/>
                                <div className="overlay rounded-top"></div>
                                <div className="post-meta">
                                    <Link to="#" className="text-white title-dark d-block text-end like"><i className="mdi mdi-heart"></i> 33</Link>
                                    <Link to="#" className="text-white title-dark read-more">Read More <i className="mdi mdi-chevron-right align-middle"></i></Link>
                                </div>
                            </div>
                            <div className="content p-3">
                                <small className="text-muted p float-end">{item.date}</small>
                                <small><Link to="#" className="text-primary">{item.tag}</Link></small>
                                <h4 className="mt-2"><Link to={`/blog-standard-post/${item.id}`} className="text-dark title">{item.title}</Link></h4>
                                <p className="text-muted mt-2">{item.desc}</p>
                                <div className="pt-3 mt-3 border-top d-flex">
                                    <img src={item.clientImg} className="img-fluid avatar avatar-ex-sm rounded-pill me-3 shadow" alt=""/>
                                    <div className="author mt-2">
                                        <h6 className="mb-0"><Link to="#" className="text-dark name">{item.clientName}</Link></h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
  )
}
